
import Component, { mixins } from "vue-class-component";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import { ProxyTableData } from '@/UI/components/Helpers/ProxyTableData';
import { SalaryCalculationsTable } from "@/UI/pages/SalaryСalculations/lib/table";

@Component({
    components: {
        PageTitle,
        BaseDataForm,
    }
})

export default class CosmetologCard extends mixins (ProxyTableData, SalaryCalculationsTable) {
    data: any = [
        {
            key0: 'ДатаДатаДатаДатаДатаДатаДатаДатаДатаДатаДатаДатаДатаДатаДатаДатаДатаДатаДата',
            key1: 'СтатСтатьяСтатьяСтатьяСтатьяСтатьяСтатьяСтатьяСтатьяСтатьяСтатьяСтатьяья',
            key2: 'ТоварУлсгаТоварУлсгаТоварУлсгаТоварУлсга',
            key3: 'ПравиларасчетаПравиларасчетаПравиларасчетаПравиларасчета',
            key4: 'стоимостьстоимостьстоимость',
            key5: 'себестоимостьсебестоимость',
            key6: '12312',
        },
        {
            key0: 'ДатаДатаДатаДатаДатаДатаДатаДатаДатаДатаДатаДатаДатаДатаДатаДатаДатаДатаДата',
            key1: 'СтатСтатьяСтатьяСтатьяСтатьяСтатьяСтатьяСтатьяСтатьяСтатьяСтатьяСтатьяья',
            key2: 'ТоварУлсгаТоварУлсгаТоварУлсгаТоварУлсга',
            key3: 'ПравиларасчетаПравиларасчетаПравиларасчетаПравиларасчета',
            key4: 'стоимостьстоимостьстоимость',
            key5: 'себестоимостьсебестоимость',
            key6: '12312',
        }
    ]


    async created() {
        this.formReady = true
    }

}
